export default __webpack_public_path__ + "static/media/20s_storyicon.0c8f43e9.png";